<template>
    <transition name="modal--fade">
        <div class="modal">
            <div class="modal__body">
                <!-- Icon -->
                <div class="modal__body__icon">
                    <slot name="icon">
                        <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#dcb47d" fill-rule="evenodd">
                                <path d="m8 1.33333333c-3.676 0-6.66666667 2.99066667-6.66666667 6.66666667s2.99066667 6.6666667 6.66666667 6.6666667 6.6666667-2.9906667 6.6666667-6.6666667-2.9906667-6.66666667-6.6666667-6.66666667m0 14.66666667c-4.41133333 0-8-3.5886667-8-8 0-4.41133333 3.58866667-8 8-8 4.4113333 0 8 3.58866667 8 8 0 4.4113333-3.5886667 8-8 8"></path>
                                <path d="m8 12c-.36666667 0-.66666667-.3-.66666667-.6666667v-3.3333333c0-.36666667.3-.66666667.66666667-.66666667s.66666667.3.66666667.66666667v3.3333333c0 .3666667-.3.6666667-.66666667.6666667"></path>
                                <path d="m8 6c-.36666667 0-.66666667-.3-.66666667-.66666667v-.66666666c0-.36666667.3-.66666667.66666667-.66666667s.66666667.3.66666667.66666667v.66666666c0 .36666667-.3.66666667-.66666667.66666667"></path>
                            </g>
                        </svg>
                    </slot>
                </div>

                <!-- Title -->
                <div class="modal__body__title">
                    <slot name="title"></slot>
                </div>

                <!-- Content -->
                <div class="modal__body__content">
                    <slot name="content"></slot>
                </div>

                <!-- Modal Close -->
                <div class="modal__body__footer">
                    <slot name="footer">
                        <button type="button" class="button button--white button--outline button--modal"
                                @click="$emit('close:clicked')">
                            <span>schließen</span>
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Modal"
    }
</script>

<style scoped>

</style>
